import create from "zustand";

const usePackages = create((set) => ({
  packagesOptions: [],
  addPackagesOptions: (data) => set({ packagesOptions: data }),
}));

export default usePackages;
